"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BATCH_PAYMENT_NETWORK_ID = exports.ESCROW_STATE = exports.STREAM_EVENT_NAMES = exports.BALANCE_ERROR_CODE = exports.ESCROW_EVENTS_NAMES = exports.EVENTS_NAMES = void 0;
/** payment network event names */
var EVENTS_NAMES;
(function (EVENTS_NAMES) {
    EVENTS_NAMES["PAYMENT"] = "payment";
    EVENTS_NAMES["REFUND"] = "refund";
    EVENTS_NAMES["ESCROW"] = "escrow";
})(EVENTS_NAMES || (exports.EVENTS_NAMES = EVENTS_NAMES = {}));
var ESCROW_EVENTS_NAMES;
(function (ESCROW_EVENTS_NAMES) {
    ESCROW_EVENTS_NAMES["PAID_ESCROW"] = "paidEscrow";
    ESCROW_EVENTS_NAMES["PAID_ISSUER"] = "paidIssuer";
    ESCROW_EVENTS_NAMES["INITIATE_EMERGENCY_CLAIM"] = "initiateEmergencyClaim";
    ESCROW_EVENTS_NAMES["REVERT_EMERGENCY_CLAIM"] = "revertEmergencyClaim";
    ESCROW_EVENTS_NAMES["FREEZE_ESCROW"] = "freezeEscrow";
})(ESCROW_EVENTS_NAMES || (exports.ESCROW_EVENTS_NAMES = ESCROW_EVENTS_NAMES = {}));
/** Balance error codes */
var BALANCE_ERROR_CODE;
(function (BALANCE_ERROR_CODE) {
    BALANCE_ERROR_CODE[BALANCE_ERROR_CODE["UNKNOWN"] = 0] = "UNKNOWN";
    BALANCE_ERROR_CODE[BALANCE_ERROR_CODE["WRONG_EXTENSION"] = 1] = "WRONG_EXTENSION";
    BALANCE_ERROR_CODE[BALANCE_ERROR_CODE["NETWORK_NOT_SUPPORTED"] = 2] = "NETWORK_NOT_SUPPORTED";
    BALANCE_ERROR_CODE[BALANCE_ERROR_CODE["VERSION_NOT_SUPPORTED"] = 3] = "VERSION_NOT_SUPPORTED";
})(BALANCE_ERROR_CODE || (exports.BALANCE_ERROR_CODE = BALANCE_ERROR_CODE = {}));
/**
 * ERC777 networks and events
 */
var STREAM_EVENT_NAMES;
(function (STREAM_EVENT_NAMES) {
    STREAM_EVENT_NAMES["START_STREAM"] = "start_stream";
    STREAM_EVENT_NAMES["END_STREAM"] = "end_stream";
    STREAM_EVENT_NAMES["UPDATE_STREAM"] = "update_stream";
})(STREAM_EVENT_NAMES || (exports.STREAM_EVENT_NAMES = STREAM_EVENT_NAMES = {}));
var ESCROW_STATE;
(function (ESCROW_STATE) {
    ESCROW_STATE["PAID_ESCROW"] = "paidEscrow";
    ESCROW_STATE["IN_FROZEN"] = "frozen";
    ESCROW_STATE["IN_EMERGENCY"] = "emergency";
    ESCROW_STATE["PAID_ISSUER"] = "paidIssuer";
})(ESCROW_STATE || (exports.ESCROW_STATE = ESCROW_STATE = {}));
/** Each paymentNetworkId is linked with a batch function */
var BATCH_PAYMENT_NETWORK_ID;
(function (BATCH_PAYMENT_NETWORK_ID) {
    BATCH_PAYMENT_NETWORK_ID[BATCH_PAYMENT_NETWORK_ID["BATCH_MULTI_ERC20_CONVERSION_PAYMENTS"] = 0] = "BATCH_MULTI_ERC20_CONVERSION_PAYMENTS";
    BATCH_PAYMENT_NETWORK_ID[BATCH_PAYMENT_NETWORK_ID["BATCH_ERC20_PAYMENTS"] = 1] = "BATCH_ERC20_PAYMENTS";
    BATCH_PAYMENT_NETWORK_ID[BATCH_PAYMENT_NETWORK_ID["BATCH_MULTI_ERC20_PAYMENTS"] = 2] = "BATCH_MULTI_ERC20_PAYMENTS";
    BATCH_PAYMENT_NETWORK_ID[BATCH_PAYMENT_NETWORK_ID["BATCH_ETH_PAYMENTS"] = 3] = "BATCH_ETH_PAYMENTS";
    BATCH_PAYMENT_NETWORK_ID[BATCH_PAYMENT_NETWORK_ID["BATCH_ETH_CONVERSION_PAYMENTS"] = 4] = "BATCH_ETH_CONVERSION_PAYMENTS";
})(BATCH_PAYMENT_NETWORK_ID || (exports.BATCH_PAYMENT_NETWORK_ID = BATCH_PAYMENT_NETWORK_ID = {}));
